import type { TGenderType } from '@/types/product'

export type TProductTabConfig = {
  key: string
  label: string
  gender?: TGenderType
}

export const PRODUCT_TAB_LIMIT = 12

// Query dùng chung cho server (tab đầu) và client (các tab sau) để kết quả đồng nhất
export const buildProductTabQuery = (sort?: string, gender?: TGenderType) => ({
  sort,
  gender_type: gender,
  page: 1,
  flatten: 0,
  force_flatten: 0,
})

export const buildCollectionHref = (slug: string, gender?: TGenderType) =>
  gender
    ? `/collection/${slug}?gender_type=${gender.toLowerCase()}`
    : `/collection/${slug}`
